export const FIRST_NAME = "firstName";
export const LAST_NAME = "lastName";
export const DATE_OF_BIRTH = "dateOfBirth";
export const EMAIL = "email";
export const CONFIRM_EMAIL = "confirm_email";
export const MOBILE = "mobile";
export const COMMENTS = "comments";
export const HEALTH_FUND = "healthFund";
export const CARD_NUMBER = "cardNumber";
export const CARD_POSITION = "cardPosition";
export const CUSTOM_FIELDS = "customFields";



// WEBPACK FOOTER //
// ./src/modules/ContactForm/consts/formKeys.js